import { TextField, TextFieldProps } from "@mui/material";

interface IProps {
	value: any;
	setValue(value: any): void;
	keyValue: string;
	inputProps?: TextFieldProps;
	className?: string;
	multiline?: boolean;
}

const DataTextField = (props: IProps) => {
	return (
		<TextField
			multiline={props.multiline}
			className={props.className || ""}
			value={props.value[props.keyValue] || ""}
			variant={"standard"}
			{...props.inputProps}
			onChange={(e) => {
				var eventVal = { ...props.value };
				if (!e.target.value) delete eventVal[props.keyValue];
				else eventVal[props.keyValue] = e.target.value;
				props.setValue({ ...eventVal });
			}}
		/>
	);
};

export default DataTextField;
